<div [ngSwitch]="errorCode" class="row">
  <div class="error">
    <ng-container *ngSwitchCase="errorCodeName.Forbidden">
      <img src="assets/images/empty/ill-access-denied.svg" />
      <p class="error__title bold">{{ 'error.access_denied.title' | translate }}</p>
      <p class="error__text px-8" [innerHTML]="'error.access_denied.text' | translate: { link: '#' }"></p>
    </ng-container>
    <ng-container *ngSwitchCase="errorCodeName.Unauthorized">
      <img src="assets/images/empty/ill-access-denied.svg" />
      <p class="error__title bold">{{ 'error.unauthorized.title' | translate }}</p>
      <p class="error__text px-8">{{ 'error.unauthorized.text' | translate }}</p>
    </ng-container>
    <!-- TODO: investigate how to translate 'error.access_not_granted.title' in case of login failure -->
    <ng-container *ngSwitchCase="errorCodeName.Conflict">
      <img src="assets/images/empty/ill-access-denied.svg" />
      <p class="error__title bold">Access not granted</p>
      <p class="error__text px-8">
        You do not currently have access to this page. If you would like to get access, please
        <a href="mailto:GCCFeedback@deloitte.com?Subject=Requesting access to Deloitte SolveIt" class="bold">contact</a>
        us
      </p>
    </ng-container>
    <!-- TODO: investigate how to translate 'error.not_supported.titl
      e' in case of mobile -->
    <ng-container *ngSwitchCase="errorCodeName.Mobile">
      <img src="assets/images/empty/ill-no-mobile.svg" />
      <p class="error__title bold">Under construction</p>
      <p class="error__text px-8">
        We are working on a mobile <br />
        experience for SolveIt at this time.
      </p>
      <p class="error__text px-8">
        Please access <a href="https://solveit.deloitte.com">https://solveit.deloitte.com</a> <br />
        on your laptop.
      </p>
    </ng-container>
    <!-- TODO: investigate how to translate 'error.not_supported.title' in case of mobile -->
    <ng-container *ngSwitchCase="errorCodeName.IE">
      <img src="assets/images/empty/ill-no-ie.svg" />
      <p class="error__title bold">Internet Explorer is not supported</p>
      <p class="error__text px-8">
        For the full and smooth experience, we recommend you <br />
        to use EDGE or Chrome browser.
      </p>
    </ng-container>
    <ng-container *ngSwitchCase="errorCodeName.MemberFirm">
      <img src="assets/images/empty/ill-member-firm-access-denied.svg" />
      <p class="error__title bold">SolveIt is currently not supporting your region yet.</p>
      <p class="error__text">
        You are welcome to look around and see what we are working on for Deloitte US.<br />
        If you have an actual issue you need help with, please connect with your <br />
        <a href="https://resources.deloitte.com/sites/global/core/Pages/Contact-Center.aspx">
          local Contact Center team
        </a>
        for support. <br /><br />
        <button (click)="navigateToApp()" class="btn btn-primary">Ok</button>
      </p>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <img src="assets/images/empty/ill-access-denied.svg" />
      <p class="error__title bold">{{ 'error.default.title' | translate }}</p>
      <p class="error__text px-8">{{ 'error.default.text' | translate }}</p>
    </ng-container>
  </div>
</div>
